import { I18n } from "../../hooks/useTranslations";
import { CostCenter } from "../costCenter/types";
import { Item } from "../item/types";
import { Priority } from "../priority/types";
import { ProcessingType } from "../processingType/type";
import { Supplier } from "../supplier/types";
import { User } from "../user/type";

export type ProcessingRequestStatus =
  | "1_open"
  | "2_accepted"
  | "3_waiting-confirmation"
  | "5_offer-approved"
  | "6_in-progress"
  | "7_closed"
  | "4_refused"
  | "8_discarded";

export const ProcessingRequestStatuses: {
  Open: ProcessingRequestStatus;
  Accepted: ProcessingRequestStatus;
  WaitingConfirmation: ProcessingRequestStatus;
  OfferApproved: ProcessingRequestStatus;
  InProgress: ProcessingRequestStatus;
  Closed: ProcessingRequestStatus;
  Refused: ProcessingRequestStatus;
  Discarded: ProcessingRequestStatus;
} = {
  Open: "1_open",
  Accepted: "2_accepted",
  WaitingConfirmation: "3_waiting-confirmation",
  OfferApproved: "5_offer-approved",
  InProgress: "6_in-progress",
  Closed: "7_closed",
  Refused: "4_refused",
  Discarded: "8_discarded",
};

export function formatStatus(status: ProcessingRequestStatus, i18n: I18n): string {
  switch (status) {
    case ProcessingRequestStatuses.Open:
      return i18n.t.processingRequests.status.open;
    case ProcessingRequestStatuses.Accepted:
      return i18n.t.processingRequests.status.accepted;
    case ProcessingRequestStatuses.WaitingConfirmation:
      return i18n.t.processingRequests.status.waitingConfirmation;
    case ProcessingRequestStatuses.OfferApproved:
      return i18n.t.processingRequests.status.offerApproved;
    case ProcessingRequestStatuses.InProgress:
      return i18n.t.processingRequests.status.inProgress;
    case ProcessingRequestStatuses.Closed:
      return i18n.t.processingRequests.status.closed;
    case ProcessingRequestStatuses.Refused:
      return i18n.t.processingRequests.status.refused;
    case ProcessingRequestStatuses.Discarded:
      return i18n.t.processingRequests.status.discarded;
    default:
      return status;
  }
}

type FinalItem = {
  id: string;
  code: string;
  quantity: number;
  unitOfMeasure: string;
};

export type ProcessingRequest = {
  id: number;
  createdAt: string;
  author: User;
  processingType: ProcessingType;
  priority: Priority;
  notes: string | null;
  supplier: Supplier | null;
  status: ProcessingRequestStatus;
  costCenter: CostCenter | null;
  productionMinutes: number | null;
  supervisor: User | null;
  expectedMinutes: number | null;
  pickingNumber: string | null;
  offerMandatory: boolean;
  costPerHour: number;
  finalItems: FinalItem[];
  offerAcceptor: User | null;
  availabilityDate: string | null;
  isKit: boolean;
};

export type ItemGroupedProcessingRequests = {
  item: Item;
  nrOfRequests: number;
  expectedTotalMinutes: number;
  totalExpectedMinutesCosts: number;
  productionTotalMinutes: number;
  totalProductionMinutesCosts: number;
  totalItemsCosts: number;
  totalPackagingsLabelsCosts: number;
};

export type InsertProcessingRequestInitialItem = {
  itemID: string;
  quantity: number;
};

export type InsertProcessingRequestFinalItem = {
  finalItemID: string;
  finalItemQuantity: number;
  initialItems: InsertProcessingRequestInitialItem[];
};

export type InsertProcessingRequest = {
  typeId: string;
  priorityId: string;
  notes: string | null;
  supplierCode: string | null;
  costCenterCode: string | null;
  pickingNumber: string | null;
  offerMandatory: boolean;
  finalItems: InsertProcessingRequestFinalItem[];
  offerAcceptor: string | null;
  isKit: boolean;
};

// export type InsertProcessingRequestForKit = {
//   typeId: string;
//   priorityId: string;
//   notes: string | null;
//   supplierCode: string | null;
//   costCenterCode: string | null;
//   pickingNumber: string | null;
//   offerMandatory: boolean;
//   finalItemId: string;
//   finalItemQuantity: number;
//   initialItems: InsertProcessingRequestInitialItemBody[];
//   offerAcceptor: string | null;
//   isKit: boolean;
// };

export type UpdateProcessingRequest = {
  priorityId: string;
  supplierCode: string | null;
  costCenterCode: string | null;
  pickingNumber: string | null;
  offerAcceptor: string | null;
};

export type UpdateRequestMinutes = {
  productionMinutes: number | null;
  expectedMinutes: number | null;
  costPerHour: number;
};

export type UpdateRequestAvailabilityDate = {
  availabliityDate: string | null;
};

// export type UpdateProcessingRequestBodyForKit = {
//   priorityId: string;
//   notes: string | null;
//   supplierCode: string | null;
//   status: ProcessingRequestStatus;
//   costCenterCode: string | null;
//   productionMinutes: number | null;
//   expectedMinutes: number | null;
//   pickingNumber: string | null;
//   costPerHour: number;
//   finalItemId: string;
//   finalItemQuantity: number;
// };

export type SearchProcessingRequestResponse = {
  items: ProcessingRequest[];
  total: number;
};
